<script setup>
defineProps({
  label: { type: String, required: true },
  icon: { type: String, default: 'i-lucide-plus' },
});

const emit = defineEmits(['select']);
</script>

<template>
  <button
    type="button"
    :aria-label="label"
    class="flex min-h-[14.5rem] w-full flex-col items-center justify-center gap-4 rounded-lais border border-lais-primary/30 bg-white p-5 text-center text-lais-primary shadow-lais-soft transition hover:border-lais-primary hover:bg-lais-primary-50/30 focus-visible:outline-none focus-visible:shadow-lais-focus"
    data-test="sales-party-quick-add"
    @click="emit('select')"
  >
    <span class="size-[60px]" :class="icon" aria-hidden="true" />
    <span class="max-w-36 text-sm font-semibold leading-5 text-lais-text">
      {{ label }}
    </span>
  </button>
</template>
